import { Component, inject, Input } from '@angular/core';
import { WindowHelperService } from '@anecdotes/utils';
import { APP_CONFIG } from '@anecdotes/configuration-data-access';

@Component({
  selector: 'app-update-prompt',
  templateUrl: './update-prompt.component.html',
})
export class UpdatePromptComponent {
  private readonly appConfig = inject(APP_CONFIG);
  private readonly windowHelperService = inject(WindowHelperService);
  
  @Input()
  activateUpdateCallback: () => void;

  protected activateUpdate(): void {
    this.windowHelperService.openUrlInNewTab(this.appConfig.redirectUrls.releaseNotes);

    if (this.activateUpdateCallback) {
      this.activateUpdateCallback();
    }
  }

  protected buildTranslationKey(relativeKey: string): string {
    return `applicationUpdatePrompt.${relativeKey}`;
  }
}
